import { FreeMode } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import styled from 'styled-components'

import { Chip } from '../chip'

interface CategoryProps {
  categoryList: { id: number | undefined; name: string; description: string; sortIndex: number }[]
  categoryId: number | undefined
  setCategoryId: (id: number | undefined) => void
}

export function Category({ categoryList, categoryId, setCategoryId }: CategoryProps) {
  return (
    <StyledSwiper autoHeight={true} freeMode={true} slidesPerView="auto" spaceBetween={8} modules={[FreeMode]}>
      <SlideItem>
        <Chip $color={typeof categoryId === 'undefined' ? 'black' : 'white'} onClick={() => setCategoryId(undefined)}>
          전체
        </Chip>
      </SlideItem>
      {categoryList.map(({ id, name }, index) => {
        const isActive = categoryId === id

        const handleCategoryId = () => setCategoryId(id)

        return (
          <SlideItem key={index}>
            <Chip $color={isActive ? 'black' : 'white'} onClick={handleCategoryId}>
              {name ?? '-'}
            </Chip>
          </SlideItem>
        )
      })}
    </StyledSwiper>
  )
}

const StyledSwiper = styled(Swiper)`
  margin: 0;
  padding: 0 16px;
`

const SlideItem = styled(SwiperSlide)`
  width: auto !important;
  height: 35px !important;
  line-height: 100%;
`
